module.exports = __webpack_public_path__ + "static/img/verification-code.e1f3d54d.svg";